module.exports = __webpack_public_path__ + "static/media/tex-trends-selection-fw2526.385f10cc.jpg";